import { createContext } from 'react'
import type { Context } from 'react'
import type { PromotionStateType } from 'storeContext/reducers/promotion'
import type { PromotionDispatchType } from 'storeContext/actions/promotion'

export type PromotionContextValueType = {
  state: PromotionStateType
  dispatch: PromotionDispatchType
}

// Preserve the legacy raw-state default while typing the provider value.
export const createPromotionContext = (initialState: PromotionStateType) =>
  createContext(initialState) as unknown as Context<PromotionContextValueType>
